import Vue from "vue";
import api from "@/modules/settings/api";
import * as consts from "@/modules/settings/store/users/consts";

const initialState = {
  users: []
};

const actions = {
  async getUsers({ commit }) {
    const { data } = await api.users.list();
    commit(consts.SET_USERS, data);
  },
  async deleteUser({ commit }, user) {
    await api.users.delete(user.id);
    commit(consts.DELETE_USER, user);
  },
  async createUser({ commit }, user) {
    const { data } = await api.users.create(user);
    commit(consts.ADD_USER, data);
  },
  async updateUser({ commit }, user) {
    const { data } = await api.users.update(user);
    commit(consts.UPDATE_USER, data);
  }
};

const mutations = {
  [consts.SET_USERS](state, users) {
    state.users = users;
  },
  [consts.DELETE_USER]({ users }, user) {
    const index = users.findIndex(item => item.id === user.id);
    Vue.delete(users, index);
  },
  [consts.ADD_USER]({ users }, user) {
    users.push(user);
  },
  [consts.UPDATE_USER]({ users }, user) {
    const index = users.findIndex(item => item.id === user.id);
    Vue.set(users, index, user);
  }
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations
};
